import React from "react";
import { Button, Modal } from "react-bootstrap";

export const allModels = {
  logout: {
    title: "Do you want to Logout?",
    cancelText: "No",
    confirmText: "Yes",
  },
  delete: {
    title: "Are you sure you want to delete ?",
    cancelText: "No",
    confirmText: "Delete",
  },
};

const ConfirmModel = ({ modelStatus, confirmHandler, setModel, type }) => {
  return (
    <Modal
      show={modelStatus}
      onHide={() => {
        setModel(false);
      }}
      className="deleteAdd-pop delete-pop"
      centered
    >
      <Modal.Body>
        <div className="text-center py-3">
          <div className="icn my-3">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256    C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216    c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"
                fill="#f8c886"
              ></path>
              <path
                d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877    C276,137.831,267.046,128.877,256,128.877z"
                fill="#f8c886"
              ></path>
              <circle cx="256" cy="349.16" r="27" fill="#f8c886"></circle>{" "}
            </svg>
          </div>
          <h2 className="pop-head m-0 pb-2">{allModels[type].title}</h2>
          <div className="btn-wrap my-2 d-flex align-items-center justify-content-center mt-3 gap-10">
            <div className="pe-2 w-50">
              <Button
                className="btn-2 w-100 d-flex align-items-center justify-content-center commonBtn"
                onClick={() => {
                  setModel(false);
                }}
              >
                {allModels[type].cancelText}
              </Button>
            </div>
            <div className="pe-2 w-50">
              <Button
                onClick={confirmHandler}
                className=" w-100 d-flex align-items-center justify-content-center commonBtn"
              >
                {allModels[type].confirmText}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModel;
